import { ProjectAssets, ImageAssets, VideoAssets, DownloadAssets } from '@models';
import * as Download_01 from './Final Fantasy Tactics WotL EU Mesiah v0.85f.zip';
import * as Title_01 from './Title_01.png';
import * as Image_01 from './Image_01.png';

export const Title: ImageAssets = {
    Title_01
};

export const Images: ImageAssets = {
    Image_01
};

export const Videos: VideoAssets = {
};

export const Downloads: DownloadAssets = {
    Download_01
};

const DinoQuest: ProjectAssets = {
    Title,
    Images,
    Videos,
    Downloads
};

export default DinoQuest;